import { ChevronRightRounded, Share } from '@material-ui/icons';
import { getCfaActions } from '@webapps/business';
import { PaginationNumbers, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { InfoTooltip, useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import ModalOpco from './ModalOpco';
import Nodata from 'components/NoData';
import theme from '../theme';

export default function Actions() {
  const { classes, global } = useStyles(styles);

  const { idUser } = useAuth();
  const { push } = useHistory();

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(3);
  const [open, setOpen] = useState(false);

  const {
    images: { Actions }
  } = theme

  const { data: { content: actions = [], totalElements } = [] } = useQuery(getCfaActions, {
    key: ['actions', size, page],
    variables: {
      id: idUser,
      size,
      page: page - 1,
    },
    keepPreviousData: true,
  });

  const actionsData = [
    { title: 'Formation', status: 'à compléter', value: 'TRAINING_COMPLETE' },
    { title: 'Contrat', status: 'à envoyer', value: 'CONTRACT_TO_SEND' },
    { title: 'Contrat', status: 'à signer', value: 'CONTRACT_TO_SIGN' },
    { title: 'Dossier', status: 'à envoyer', value: 'RECORD_TO_SEND' },
    { title: 'Facture', status: 'à générer', value: 'BILLING_TO_GENERATE' },
    { title: 'Modèle de convention', status: 'à générer', value: 'CONVENTION_MODEL_TO_GENERATE' },
    { title: 'Organisme de formation', status: 'à inviter', value: 'SCHOOL_TO_INVITE' },
    { title: 'Se connecter', status: 'à un OPCO', value: 'CONNECT_TO_OPCO' },
    { title: 'Clé OPCO', status: 'arrivant à expiration', value: 'OPCO_KEY_EXPIRING' },
    { title: 'Clé OPCO', status: 'expiré', value: 'OPCO_KEY_EXPIRED' },
    { title: 'Erreur', status: 'sur un dossier', value: 'RECORD_ERROR' },
  ];

  const handleClick = (action) => {
    switch (action.value) {
      case 'TRAINING_COMPLETE':
        push(ROUTES_PATH.CFA_ORGANISMES, { toTraining: true });
        break;
      case 'CONTRACT_TO_SEND':
        push(ROUTES_PATH.CFA_RECORDS, { status: "READY" });
        break;
      case 'CONTRACT_TO_SIGN':
        push(ROUTES_PATH.CFA_RECORDS, { status: "PENDING" });
        break;
      case 'RECORD_TO_SEND':
        push(ROUTES_PATH.CFA_RECORDS, { status: "PENDING" });
        break;
      case 'BILLING_TO_GENERATE':
        push(ROUTES_PATH.CFA_RECORDS);
        break;
      case 'CONVENTION_MODEL_TO_GENERATE':
        push(ROUTES_PATH.CFA_CONTRACT);
        break;
      case 'SCHOOL_TO_INVITE':
        push(ROUTES_PATH.CFA_ORGANISMES, { generateCode: true });
        break;
      case 'RECORD_ERROR':
        push(ROUTES_PATH.CFA_RECORDS, { status: "ERROR,ERROR-CERFA-UPLOAD,ERROR-CONTRACT-UPLOAD,ERROR-CONVENTION-UPLOAD,FORBIDDEN" });
        break;
      case 'CONNECT_TO_OPCO':
        setOpen(true);
        break;
      case 'OPCO_KEY_EXPIRING':
        setOpen(true);
        break;
      case 'OPCO_KEY_EXPIRED':
        setOpen(true);
        break;
      default:
        console.log('Unknown action type');
    }
  };


  const mappedActions = actions.map(action => {
    const action2 = actionsData.find(btn => btn.value === action.value) || {};
    return {
      count: action.count,
      title: action2.title || 'Unknown',
      status: action2.status || 'Unknown',
      value: action2.value || 'Unknown',
    };
  });
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={global.title}>{totalElements || 0} Actions à faire</div>
        <InfoTooltip
          position="bottom"
          forceVisible={false}
          title="Comment ça marche ?"
          description="Cette section liste toutes les actions en attente que vous devez traiter pour assurer le suivi de vos dossiers d'apprentissage."
          link={{ text: "En savoir plus", onClick: () => push(ROUTES_PATH.CFA_ORGANISMES, { generateCode: true }) }}
        />
      </div>
      <div className={classes.actionsContainer}>
        {mappedActions && mappedActions.length > 0 ? (
          <>
            {mappedActions.map((action, index) => (
              <div key={index} className={classes.actionButton} onClick={() => handleClick(action)}>
                <div className={classes.actionContent}>
                  <div className={classes.countContainer}>
                    <div className={classes.count}>{action.count}</div>
                  </div>
                  <div className={classes.actionText}>
                    {action.title} <strong className={classes.actionStatus}>{action.status}</strong>
                  </div>
                </div>
                <div className={classes.date}>Dernière action reçue le 31/08/2025</div>
                <div className={classes.iconButton} id="iconButton">
                  <ChevronRightRounded className={classes.icon} style={{ fill: action.iconColor }} />
                </div>
              </div>
            ))}
            <div className={classes.pagination}>
              <PaginationNumbers
                onChange={(newPage) => setPage(newPage)}
                page={page}
                pageCount={size}
                totalCount={totalElements}
              />
            </div>
          </>
        ) : (
          <Nodata
            title="Aucune action à faire"
            description="Connectez-vous auprès d'un organisme de formation pour synchroniser la récupération des dossiers de professionnalisation"
            image={Actions}
            contentWidth="70%"
            padding="0px 20px 20px 0px"
          />
        )}
      </div>
      <ModalOpco open={open} onCancel={() => setOpen(false)} />
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: '20px',
    gap: '20px',
    height: '100%',
    overflow: 'visible',
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    overflow: 'visible',
  },
  title: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '14px',
    color: '#152652',
  },
  iconHeader: {
    height: '16px',
    width: '16px',
    fill: '#a8caff',
  },
  actionsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '10px',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  actionButton: {
    border: '1px dashed #c0d9ff',
    backgroundColor: '#f3f7ff',
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    width: '100%',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: "white",
      '& #iconButton': {
        borderColor: '#0060f9',
      },
      '& #iconButton svg': {
        fill: '#0060f9',
      },
    },
  },
  actionContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    overflow: 'hidden',
  },
  countContainer: {
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 10px',
    backgroundColor: '#c0d9ff',
  },
  count: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '12px',
    lineHeight: '12px',
    textAlign: 'center',
    color: '#0060f9',
  },
  actionText: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '14px',
    lineHeight: '14px',
    color: '#152652',
  },
  actionStatus: {
    fontWeight: 'bold',
  },
  date: {
    display: 'none', // Refaire le système de notification
    fontFamily: '"Roboto", sans-serif',
    fontSize: '12px',
    lineHeight: '12px',
    color: '#5d75a8',
  },
  iconButton: {
    border: '1px solid #c0d9ff',
    backgroundColor: '#ffffff',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0',
  },
  icon: {
    height: '20px',
    width: '20px',
    color: '#5d75a8',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  }
});